import { Pipe, PipeTransform } from "@angular/core";
import { UrlSegment } from "@angular/router";

@Pipe({
  standalone: true,
  name: 'resourcesHeader'
})
export class ResourcesHeaderPipe implements PipeTransform {
  transform(categoryID: string) {
    switch (categoryID) {
      case 'small-group':
        return 'Small Group Instruction';
      case 'student-engagement':
        return 'Student Engagement';
      case 'resources':
        return 'Knowledge Base';
    }

    return '';
  }
}
